<template>
  <div class="button" :class="{
    'button--special': special,
  }">
    <component class="button__content animated pulse infinite"
      :is="component"
      v-bind="$attrs"
      v-on="$listeners"
    >
      <slot />
    </component>
  </div>
</template>

<script>
export default {
  name: 'VButton',
  inheritAttrs: false,

  props: {
    special: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    component() {
      return this.$attrs.to ? 'router-link' : 'a';
    },
  },
};
</script>

<style lang="scss" scoped>
.button {
  max-width: 400px;
  margin: 0 auto;

  &,
  &__content {
    display: block;
    width: 100%;
  }

  &__content {
    display: flex;
    align-items: center;
    justify-content: center;

    padding: 10px;

    font-family: 'Anton', Arial, Helvetica, sans-serif;
    color: #ffffff;
    font-size: 50px;
    line-height: 1.25em;
    text-decoration: none;
    text-align: center;
    text-transform: uppercase;

    background-color: #55b996;
    
    box-shadow: 4.7px 6.5px 21px 0 rgba(0, 0, 0, 0.68);

    cursor: pointer;

    @media screen and (max-width: 900px) {
      font-size: 30px;
      line-height: 1.25em;
    }

    @media screen and (max-width: 600px) {
      font-size: 28px;
      line-height: 1.25em;
    }

    &:hover {
      color: #000000;
    }
  }

  &--special &__content {
    background-color: #ff2128;
  }
}
</style>
